import {
    createApp
} from 'vue'
import Antd from 'ant-design-vue';
import App from './App.vue'
import store from './store/index'
import config from '@/methods/config.js'
import methods from '@/methods/methods.js'
import 'ant-design-vue/dist/antd.less';

import '@/assets/css/global.css'
import '@/assets/css/font.css'

import router from './router/index'

import TableList from '@/components/table.vue'
import TreeTable from '@/components/treeTable.vue'
import SearchForm from '@/components/form.vue'
import SubmitForm from '@/components/submitForm.vue'
import upload from '@/components/upload.vue'
// import {
//     setTheme
// } from '@/methods/theme'
import '@/methods/rem.js'

    // setTheme()
  let obj = {
    'color': '#397DEE',
    'primary-color': '#397DEE',
    'link-color': '#397DEE',
    'font-size-base': '13px',
    'border-radius-base': '2px',
    'success-color': '#34C724',
    'warning-color': '#F8AC1F',
    'error-color': '#F44B47',
    'heading-color': '#333333',
    'ba-color':'#E6EEFD'
   }
    for (let key in obj) {
        document
            .getElementsByTagName("body")[0]
            .style.setProperty(`--${key}`, obj[key]);
    }
    const app = createApp(App)
    
    app.component('TableList', TableList);
    app.component('TreeTable', TreeTable);
    app.component('SearchForm', SearchForm);
    app.component('Upload', upload);
    app.component('SubmitForm', SubmitForm);
    app.config.globalProperties.$config = config;
    app.config.globalProperties.$methods = methods
    app.use(store)
    app.use(Antd)
    app.use(router).mount('#app')